exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-control-label[data-v-55e45b15] {\n    font-weight: 500;\n}\n.custom-switch .custom-control-label[data-v-55e45b15]::before {\n    border-radius: 0.5rem;\n}\n.custom-switch .custom-control-label[data-v-55e45b15]::after {\n    border-radius: 50%;\n}\n", ""]);

// exports
